import { asTypeProxy, makePathModel } from '../../../../utils/nestedPathModel';
import { Schema } from '../../../../adapters/schema';
var initialValues = {};
var fields = asTypeProxy();
var PATHS = {
    COMMENT: fields.comment,
    PREFERRED_CHANNEL: fields.preferredChannel,
};
var _a = makePathModel(PATHS), paths = _a[0], selectors = _a[1];
var validationSchema = Schema.object().shape({
    comment: Schema.string(),
});
export var advicePageFormModel = {
    initialValues: initialValues,
    paths: paths,
    selectors: selectors,
    validationSchema: validationSchema,
};
